import { TOrder } from 'src/mobx/ordersHistoryStore/types';
import OrderingChannelIcon from 'src/view/components/OrderingChannelIcon/OrderingChannelIcon';
import OrderPaymentTypeIcon from 'src/view/components/OrderPaymentTypeIcon';
import OrderDeliveryTypeIcon from 'src/view/components/OrderDeliveryTypeIcon';

const OrderHistoryDetailsCell = ({ order }: { order: TOrder }) => {
  return (
    <div className="d-flex flex-row flex-fill justify-content-between pr-4 orders-history_icons">
      <OrderDeliveryTypeIcon deliveryType={order.deliveryType} />
      <OrderPaymentTypeIcon paymentType={order.paymentType} />
      <OrderingChannelIcon orderingChannel={order.orderingChannel} />
    </div>
  );
};

export default OrderHistoryDetailsCell;
